// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__Lu6fg","description":"NotFoundBlock_description__bXsdq","link":"NotFoundBlock_link__OpBbP"};